<div class="shell-container">
  <!-- Sidebar fixed -->
  <app-sidebar></app-sidebar>

  <!-- Content area -->
  <div class="content-wrapper">
    <!-- Header con icone -->
    <app-header></app-header>

    <!-- Main content -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>
